import { $t } from '@/composables/translation'

export default function convertDecimalTimeToMinuteTime(decimalTime: number): string {
  const hours = Math.floor(decimalTime)
  const minutes = Math.round((decimalTime % 1) * 60)

  return `${hours ? `${hours}${$t('h (hour abbreviation)')}` : ''}${
    minutes ? ` ${minutes}${$t('m (minute abbreviation)')}` : ''
  }`.trim()
}
